// Path of the in-app document viewer for a blob name (slashes kept as path
// separators, every segment encoded).
export function viewerPath(blobName) {
  return `/documents/view/${String(blobName || "")
    .split("/")
    .map(encodeURIComponent)
    .join("/")}`;
}

// Inverse of the route splat: decode each segment.
export function blobFromSplat(splat) {
  return String(splat || "")
    .split("/")
    .map((seg) => {
      try { return decodeURIComponent(seg); } catch { return seg; }
    })
    .join("/");
}
